import * as types from '../types/elements'
import { PagesResource } from '../../resources/index'

export const setElements = elements => ( {
  type: types.SET_ELEMENTS,
  payload: elements
} )

export const setActiveElement = element => ( {
  type: types.SET_ACTIVE_ELEMENT,
  payload: element
} )

export const updateActualElement = element => ( {
  type: types.UPDATE_ELEMENT,
  payload: element
} )

export const addElement = element => ( {
  type: types.ADD_ELEMENT,
  payload: element
} )

export const removeElement = id => ( {
  type: types.REMOVE_ELEMENT,
  payload: id
} )

export const batchSaveElements = payload => ( {
  type: types.BATCH_UPDATE,
  payload: payload
} )

export const deleteElemet = element => ( {
  type: types.DELETE_ELEMENT,
  async: PagesResource.deletePageItem( element.id_page, element.id ),
  payload: element
} )

export const duplicateElement = element => ( {
  type: types.DUPLICATE_ELEMENT,
  payload: element
} )

export const sendElementToBack = element => ( {
  type: types.SEND_TO_BACK,
  payload: element
} )

export const sendElementToFront = element => ( {
  type: types.SEND_TO_FRONT,
  payload: element
} )

export const sendElementToBackOne = element => ( {
  type: types.SEND_TO_BACK_ONE,
  payload: element
} )

export const sendElementToFrontOne = element => ( {
  type: types.SEND_TO_FRONT_ONE,
  payload: element
} )


// WEBPACK FOOTER //
// ./src/store/actions/elements.js